import { render, staticRenderFns } from "./AcceptApplication.vue?vue&type=template&id=4dd9b605&scoped=true&"
import script from "./AcceptApplication.vue?vue&type=script&lang=js&"
export * from "./AcceptApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd9b605",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VIcon,VProgressCircular,VRow,VSnackbar})


/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dd9b605')) {
      api.createRecord('4dd9b605', component.options)
    } else {
      api.reload('4dd9b605', component.options)
    }
    module.hot.accept("./AcceptApplication.vue?vue&type=template&id=4dd9b605&scoped=true&", function () {
      api.rerender('4dd9b605', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/notifications/AcceptApplication.vue"
export default component.exports